import styled from '../../../../styles/styledComponents/themeComponents';

export const PreviewStyle = styled.div`
  position: relative;
  height: 140px;
  width: 140px;
  overflow: hidden;

  img {
    width: 100%;
    height: 140px;
    object-fit: cover;
  }

  &:before {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border: 1px solid #000;
    content: ' ';
    opacity: 0.1;
  }

  &:after {
    position: absolute;
    left: 0;
    right: 0;
    top: auto;
    bottom: 0;
    height: 45px;
    background-color: #000;
    content: ' ';
    opacity: 0.3;
    z-index: 10;
  }

  .orderNumber {
    position: absolute;
    top: 2px;

    .badge {
      font-weight: bold;
      font-size: 20px;
      padding: 0 10px;
    }
  }

  .toolbar {
    position: absolute;
    bottom: 0;
    display: table;
    margin: 0;
    width: 100%;
    height: 45px;
    z-index: ${(props) => props.theme.zIndex.imgUploadToolBar};

    a {
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      font-size: 18px;
      color: #fff;
      opacity: 0.7;
      cursor: pointer;
      background-color: transparent;

      &:hover {
        background-color: #000;
        opacity: 0.4;
      }
    }

    .update-file-input.hidden {
      display: none;
    }
  }
`;
